<template>
  <div class="banner-callback">
    <div class="banner-callback__header">
      <div class="banner-callback__title">Не знаете что подобрать?</div>
      <div class="banner-callback__subtitle">
        Оставьте свой номер и мы подберем<br />наиболее подходящий вам вариант.
      </div>
    </div>
    <form class="banner-callback__form" novalidate @submit.prevent="submitForm">
      <div class="banner-callback__fields-group">
        <div class="field">
          <NameField
            v-model="form.name"
            :invalid="Boolean(errors.name)"
            :error="showErrorsInput ? errors.name : ''"
            @update:modelValue="clearError('name')"
          />
        </div>
        <div class="field">
          <PhoneField
            v-model="form.phone"
            :invalid="Boolean(errors.phone)"
            :error="showErrorsInput ? errors.phone : ''"
            @update:modelValue="clearError('phone')"
          />
        </div>
        <div class="field">
          <EmailField
            v-model="form.email"
            :invalid="Boolean(errors.email)"
            :error="showErrorsInput ? errors.email : ''"
            @update:modelValue="clearError('email')"
          />
        </div>
      </div>
      <div class="banner-callback__email-info">
        Подпишитесь, чтобы не пропустить актуальные предложения и акции!
      </div>
      <div class="banner-callback__privacy banner-privacy">
        <!-- Отправляя свои данные вы соглашаетесь<br />с
          <a href="https://gk-osnova.ru/privacy" target="_blank">
            политикой конфиденциальности.
          </a> -->
        <div class="banner-privacy__field-checkbox">
          <input
            type="checkbox"
            name="agreement"
            v-model="form.agreement"
            class="banner-privacy__checkbox"
            :class="{ 'banner-privacy__checkbox--error': errors.agreement }"
            @change="clearError('agreement')"
          />
          <label class="banner-privacy__agreement">
            Ознакомлен(а) с
            <a
              href="/Политика_обработки_персональных_данных.pdf"
              class="banner-privacy__agreement-link"
              target="_blank"
            >
              Политикой обработки персональных данных</a
            >
            и даю
            <a
              href="/data-consent"
              class="banner-privacy__agreement-link"
              target="_blank"
            >
              согласие</a
            >
            на их обработку.
          </label>
        </div>
        <div
          v-if="showErrorsInput && errors.agreement"
          class="banner-privacy__error"
        >
          {{ errors.agreement }}
        </div>
        <div class="banner-privacy__field-checkbox">
          <input
            type="checkbox"
            name="marketing"
            v-model="form.marketing"
            class="banner-privacy__checkbox"
          />
          <label class="banner-privacy__agreement">
            Я даю согласие на получение
            <a
              href="/promotion"
              class="banner-privacy__agreement-link"
              target="_blank"
            >
              рекламных рассылок</a
            >.
          </label>
        </div>
      </div>
      <button
        type="submit"
        class="banner-callback__button btn"
        :disabled="sending"
      >
        Получить консультацию
      </button>
    </form>
    <PopupStatus
      :visible="popupVisible"
      :success="popupSuccess"
      @close="popupVisible = false"
    />
  </div>
</template>

<script>
import PhoneField from "@/components/form/PhoneField.vue";
import NameField from "@/components/form/NameField.vue";
import EmailField from "@/components/form/EmailField.vue";
import coMagicOfflineRequest from "@/coMagicOfflineRequest";
import { subscribeInFooter } from "@/mindbox";
import PopupStatus from "@/components/popup/PopupFormStatus.vue";
import formValidation, {
  requiredRule,
  phoneRule,
  emailRule,
  checkedRule,
} from "@/utils/form-validation";

export default {
  components: {
    PhoneField,
    NameField,
    EmailField,
    PopupStatus,
  },
  mixins: [formValidation],
  inject: ["captchaStore"],
  data() {
    return {
      form: {
        name: "",
        phone: "",
        email: "",
        agreement: false,
        marketing: false,
      },
      sending: false,
      // phoneInvalid: false,
      popupVisible: false,
      popupSuccess: false,
    };
  },
  computed: {
    isCaptchaVerified() {
      return this.captchaStore.state.captchaVerified;
    },
    validationRules() {
      return {
        name: [requiredRule()],
        phone: [requiredRule(), phoneRule()],
        email: [emailRule()],
        agreement: [checkedRule()],
      };
    },
  },
  methods: {
    async submitForm() {
      if (!this.isCaptchaVerified) {
        console.log("Captcha is not verified - form blocked");
        return;
      }
      if (!this.validateForm()) return;

      if (this.sending) return;

      const rawPhone = this.form.phone.replace(/\D/g, "");

      if (rawPhone.length !== 11 || !rawPhone.startsWith("7")) {
        this.phoneInvalid = true;
        return;
      } else {
        this.phoneInvalid = false;
      }

      this.sending = true;

      try {
        subscribeInFooter({
          phone: this.form.phone,
          email: this.form.email,
          isSubscribed: this.form.marketing,
        });
      } catch (e) {
        console.error("[mindbox]", e);
      }

      try {
        await coMagicOfflineRequest(this.form, "Форма с баннера", "");

        this.popupSuccess = true;
        this.popupVisible = true;
        this.form.name = "";
        this.form.phone = "";
        this.form.email = "";
        this.form.agreement = false;
        this.errors = {};
      } catch (err) {
        this.popupSuccess = false;
        this.popupVisible = true;
        console.error(err);
      } finally {
        this.sending = false;

        setTimeout(() => {
          this.popupVisible = false;
        }, 4000);
      }
    },
  },
};
</script>

<style lang="scss">
.banner-callback {
  border-radius: 25px;
  background: #ff0020;
  padding: 46px 50px;
  display: flex;
  gap: 87px;
  align-items: center;
  color: #ffffff;
  margin-top: 25px;
  &__header {
    min-width: 373px;
  }
  &__title {
    font-weight: 500;
    font-size: 30px;
    line-height: 120%;
  }
  &__subtitle {
    margin-top: 12px;
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;
  }
  &__fields-group {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    @media (max-width: 1280px) {
      flex-wrap: wrap;

      .field {
        flex: 1;
      }
    }
  }
  &__email-info {
    font-weight: 500;
    font-size: 16px;
    line-height: 19.6px;
    color: #ffffff;
    margin-bottom: 15px;
  }
  &__button {
    margin-top: 20px;
    width: 100%;
    max-width: 400px;
    min-width: 280px;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    color: #545863;
    background: #ffffff;
    padding: 22.5px 25.5px 21.5px 25.5px;
    white-space: nowrap;
    &:hover {
      background: #e5e5e5;
    }
  }
  &__privacy {
    display: flex;
    flex-direction: column;
  }

  .banner-privacy {
    &__field-checkbox {
      font-weight: 500;
      font-size: 12px;
      line-height: 120%;
      color: #ffffff;
      height: auto;
      display: flex;
      gap: 10px;
      align-items: center;

      a {
        color: #ffffff;
      }

      &:last-of-type {
        margin-top: 15px;
      }
    }
    &__checkbox {
      width: 18px;
      height: 18px;
      min-width: 18px;
      cursor: pointer;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      border: 1px solid #cbd0dd;
      border-radius: 3px;
      background-color: #fff;
      position: relative;
      flex-shrink: 0;

      &:checked {
        background-color: #ffffff;
        border-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 10'%3E%3Cpath fill='none' stroke='%23ff0020' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M1 5l3 3 7-7'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 12px 10px;
      }
    }
    &__checkbox--error {
      border-color: #fff;
    }

    &__error {
      margin-top: 5px;
      font-weight: 500;
      font-size: 12px;
      line-height: 120%;
      color: #fff;
    }
  }
  .banner-callback__button[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
}

@media (max-width: 1280px) {
  .banner-callback {
    gap: 50px;
    &__button {
      min-width: auto;
    }
  }
}

@media (max-width: 992px) {
  .banner-callback {
    flex-direction: column;
    align-items: flex-start;
    padding: 35px 18px 30px 18px;

    &__form {
      width: 100%;
    }

    &__button {
      width: 100%;
    }

    .callback-messenger-tel .input-tel-mask {
      width: 100%;
    }
  }
}

@media (max-width: 767px) {
  .banner-callback {
    gap: 25px;
    &__header {
      min-width: auto;
    }
    &__title {
      font-size: 24px;
    }
    &__fields-group {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 20px;
    }
    &__button {
      height: 55px;
      font-weight: 500;
      font-size: 16px !important;
    }
  }
}
</style>
